import { render } from "./ActionDropdown.vue?vue&type=template&id=47db7e26"
import script from "./ActionDropdown.vue?vue&type=script&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&lang=js"

import "./ActionDropdown.vue?vue&type=style&index=0&id=47db7e26&lang=scss"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__